import './styles.css'

import { Button } from "@fragments";
import { IconArrowRight } from '@tabler/icons-react'

export default function BottomSubmit({ onPress }) {
    return (
        <div className='bottom-submit'>
            <small className='text'>
                Alterações não salvas
            </small>
            <Button
                onClick={onPress}
                variant='contained'
                className='bottom-submit-btn'
                size='small'
                endIcon={<IconArrowRight size={18} />}
            >
                Salvar
            </Button>
        </div>
    )
}